import { type HeaderV3Props, LinksCategoryId } from '@jouzen/ecom-components';
import { type DynamicConfig, useConfig } from 'statsig-react';

import { POP_PATHNAME } from '@/app/consts/pathnames';
import useDefaultPdpSelections from '@/app/hooks/useDefaultPdpSelections';

import formatLinks from '../utils/formatLinks';

const SHOP_LINK_ID = 'oura-ring';

interface MenuProps extends Omit<DynamicConfig, 'value'> {
  value: {
    menuLinks: HeaderV3Props['menuLinks'];
  };
}

const useMenuConfig = (pathname: string): HeaderV3Props['menuLinks'] => {
  const { config } = useConfig('global_menu_links');
  const menuConfigValue = config.value as MenuProps['value'];
  const activeMenuConfig = Object.keys(menuConfigValue).length > 0;
  const { style: defaultPdpStyle } = useDefaultPdpSelections();

  if (!activeMenuConfig) {
    return undefined;
  }

  return formatLinks({
    basePathDestination: POP_PATHNAME,
    currentPath: POP_PATHNAME,
    pathname,
    statsigLinks: menuConfigValue.menuLinks,
    subPathDestination: defaultPdpStyle,
    targetCategoryIds: [LinksCategoryId.ShopCategory, LinksCategoryId.MenuCard],
    targetLinkId: SHOP_LINK_ID,
  });
};

export default useMenuConfig;
